import { render, staticRenderFns } from "./birthdayDetail.vue?vue&type=template&id=a8c93daa&scoped=true&"
import script from "./birthdayDetail.vue?vue&type=script&lang=js&"
export * from "./birthdayDetail.vue?vue&type=script&lang=js&"
import style0 from "./birthdayDetail.vue?vue&type=style&index=0&id=a8c93daa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c93daa",
  null
  
)

export default component.exports